export default () => {

    let tickers = document.querySelectorAll('.ticker');

    if (!tickers) {
        return;
    }


    const mediaMobile = window.matchMedia("(max-width: 1023px)");

    if (mediaMobile.matches) { // Mobile

        tickers.forEach(ticker => {

            if ("duration" in ticker.dataset) {

                let duration = (ticker.dataset.duration / 2);
                let styles = `animation-duration:${duration}s;-webkit-animation-duration:${duration}s;`;
                ticker.setAttribute("style", styles);
    
            } else {
                let styles = "animation-duration:18s;-webkit-animation-duration:18s";
                ticker.setAttribute("style", styles);
            }
    
        });

    } else { // Desktop

        tickers.forEach(ticker => {

            if ("duration" in ticker.dataset) {

                let duration = ticker.dataset.duration;
                let styles = `animation-duration:${duration}s;-webkit-animation-duration:${duration}s;`;
                ticker.setAttribute("style", styles);
    
            } else {
                let styles = "animation-duration:36s;-webkit-animation-duration:36s";
                ticker.setAttribute("style", styles);
            }
    
        });

    }

}